import * as React from "react"

export const HowItWorksIcon = ({
  width = 40,
  height = 40,
  ...rest
}: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...rest}
    width={width}
    height={height}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width={width} height={height} rx="8" fill="#F9F2FF" />
    <path
      d="M23.4319 16.5L26.9319 13M28.9319 11L26.9319 13L28.9319 11ZM19.3219 20.61C19.8383 21.1195 20.2487 21.726 20.5297 22.3948C20.8106 23.0635 20.9565 23.7813 20.9589 24.5066C20.9614 25.232 20.8203 25.9507 20.5438 26.6213C20.2674 27.2919 19.861 27.9012 19.3481 28.4141C18.8351 28.9271 18.2258 29.3334 17.5552 29.6099C16.8846 29.8864 16.1659 30.0275 15.4405 30.025C14.7152 30.0226 13.9975 29.8767 13.3287 29.5958C12.66 29.3148 12.0534 28.9043 11.5439 28.388C10.542 27.3507 9.98768 25.9614 10.0002 24.5193C10.0127 23.0772 10.5912 21.6977 11.6109 20.678C12.6307 19.6583 14.0101 19.0798 15.4522 19.0673C16.8943 19.0548 18.2836 19.6091 19.3209 20.611L19.3219 20.61ZM19.3219 20.61L23.4319 16.5L19.3219 20.61ZM23.4319 16.5L26.4319 19.5L29.9319 16L26.9319 13L23.4319 16.5Z"
      stroke="#7026B9"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
